import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/vue-query';
import { MaybeRefOrGetter } from '@vueuse/core';
import { secondsToMilliseconds } from 'date-fns';

import { fetchTokenExpirationInfo } from '../services';

export const tokenQueryKeys = createQueryKeys('requirement-token', {
  show: (requestKey: MaybeRefOrGetter<string>, authType: MaybeRefOrGetter<'whatsapp' | 'sms' | 'email'>) => [{ requestKey, authType }],
});

export function useFetchTokenExpiration(requestKey: MaybeRefOrGetter<string>, authType: MaybeRefOrGetter<'whatsapp' | 'sms' | 'email'>) {
  const result = useQuery({
    queryKey: tokenQueryKeys.show(requestKey, authType).queryKey,
    queryFn: () => fetchTokenExpirationInfo(toValue(requestKey), toValue(authType)),
    staleTime: secondsToMilliseconds(1),

    refetchOnWindowFocus: false,

    initialDataUpdatedAt: 0,
    initialData: {
      validUntil: new Date().toISOString(),
      used: false,
      resend: {
        remainingAttempts: Number.POSITIVE_INFINITY,
        blockedUntil: new Date().toISOString(),
      },
    },
  });

  return {
    ...result,
    expirationInfo: result.data,
  };
}
